module.exports = __webpack_public_path__ + "static/img/floatLeftImg1.8cdcd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floatLeftImg1.png
// module id = X27B
// module chunks = 2